import React from 'react';
import { Grid } from '@mui/material';
import { Illustrations } from '../Illustrations.js';

export function IllustrationsPage() {
  return (
    <Grid container spacing={1}>
      <Illustrations />
    </Grid>
  );
}
